export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";